// Gracias (tienda v5) — confirmación post-pago del checkout one-shot (Sub-fase 4.5).
//
// NOTA: hoy el retorno real de Checkout Pro (visitante) cae en las back_urls de la edge
// `crear-pedido-publico` (panel.limpack.uy/cliente?pago=ok), que NO se tocan en este batch
// (requiere redeploy de la edge → va con el refactor del Brick, task #7). Esta página se alcanza
// vía onCompletado del CheckoutFlow y queda lista para cuando se apunten las back_urls acá.
import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useCart } from '../../lib/CartContext';
import { ScrollHintPill } from '../../components/tienda-v5';

export default function Gracias() {
  const [params] = useSearchParams();
  const { clear } = useCart();
  const pedido = params.get('pedido') || params.get('numero_orden');
  const estadoPago = params.get('pago'); // 'ok' | 'pendiente' | 'falla' | null

  // Al llegar a gracias el pedido ya fue creado → vaciar el carrito (idempotente).
  useEffect(() => { try { clear(); } catch { /* noop */ } }, [clear]);

  const falla = estadoPago === 'falla';
  const pendiente = estadoPago === 'pendiente';

  return (
    <div className="tv5-gracias">
      <style>{GRACIAS_CSS}</style>
      <ScrollHintPill />
      <div className="tv5-gracias-card">
        <div className="tv5-gracias-emoji">{falla ? '😕' : pendiente ? '⏳' : '✅'}</div>
        <h1>
          {falla ? 'No pudimos procesar el pago' : pendiente ? 'Estamos confirmando tu pago' : '¡Gracias por tu compra!'}
        </h1>
        <p>
          {falla
            ? 'El pago no se completó. Podés reintentar desde el carrito o escribirnos por WhatsApp y lo resolvemos.'
            : pendiente
              ? 'Tu pago quedó pendiente de acreditación. Te avisamos por WhatsApp apenas se confirme.'
              : <>Recibimos tu pedido{pedido ? <> <strong>#{pedido}</strong></> : ''}. Te llega a tu puerta el día de tu barrio. Te confirmamos todo por WhatsApp.</>}
        </p>

        <div className="tv5-gracias-cta">
          {falla ? (
            <Link className="tv5-gracias-btn" to="/checkout">Reintentar el pago →</Link>
          ) : (
            <Link className="tv5-gracias-btn" to="/catalogo">Seguir comprando →</Link>
          )}
          <a className="tv5-gracias-wa" href="https://wa.me/59898610001?text=Hola!%20Tengo%20una%20consulta%20sobre%20mi%20pedido" target="_blank" rel="noopener noreferrer">💬 WhatsApp</a>
        </div>
        <Link className="tv5-gracias-home" to="/">← Volver al inicio</Link>
      </div>
    </div>
  );
}

const GRACIAS_CSS = `
.tv5-gracias {
  min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 24px;
  background: linear-gradient(135deg, #0A1424 0%, #1A3461 100%);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif; color: #F8F6F1;
}
.tv5-gracias-card {
  max-width: 460px; width: 100%; text-align: center;
  background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.1);
  border-radius: 20px; padding: 44px 28px;
}
.tv5-gracias-emoji { font-size: 56px; line-height: 1; margin-bottom: 16px; }
.tv5-gracias-card h1 { font-size: 26px; font-weight: 900; letter-spacing: -0.02em; margin: 0 0 12px; }
.tv5-gracias-card p { font-size: 14.5px; line-height: 1.6; color: rgba(248,246,241,0.75); margin: 0 0 24px; }
.tv5-gracias-cta { display: flex; gap: 10px; justify-content: center; flex-wrap: wrap; }
.tv5-gracias-btn {
  display: inline-flex; align-items: center; justify-content: center; padding: 13px 22px;
  border-radius: 999px; background: linear-gradient(135deg, #1a5cb8, #00A8B5); color: #fff;
  font-weight: 800; font-size: 14.5px; text-decoration: none; box-shadow: 0 8px 22px rgba(0,168,181,0.28);
  transition: transform 0.12s, box-shadow 0.12s;
}
.tv5-gracias-btn:hover { transform: translateY(-1px); box-shadow: 0 10px 26px rgba(0,168,181,0.38); }
.tv5-gracias-wa {
  display: inline-flex; align-items: center; justify-content: center; padding: 13px 20px;
  border-radius: 999px; background: rgba(37,211,102,0.14); border: 1px solid rgba(37,211,102,0.4);
  color: #4ade80; font-weight: 800; font-size: 14.5px; text-decoration: none;
}
.tv5-gracias-wa:hover { background: rgba(37,211,102,0.2); }
.tv5-gracias-home { display: inline-block; margin-top: 18px; color: rgba(248,246,241,0.55); font-size: 13px; text-decoration: none; }
.tv5-gracias-home:hover { color: #F8F6F1; text-decoration: underline; }
`;
